import I18n from "i18n-js"
I18n.defaultLocale = "de";
I18n.locale = "de";
I18n.translations = {"de":{"javascripts":{"appointment_search":{"components":{"venue_show":{"donation_reservation_text":{"bawuehe":"Nur mit Terminreservierung!","default":"Bitte Termin reservieren!"},"no_donation_reservation_available":{"bawuehe":"Terminreservierung noch nicht möglich"}}}}}},"en":{}};

export default I18n
